import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

@Injectable()
export class DeleteCwsIconFileDataService extends PlessJsonResponderSub<any> {
  // VO
  vo = {
    IconCode: '',
    IconCodeBranch: '',
    UpdateDate: '',
  };

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteCwsIconFileDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        IconCode: this.vo.IconCode,
        IconCodeBranch: this.vo.IconCodeBranch,
        UpdateDate: this.vo.UpdateDate
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof DeleteCwsIconFileDataService
   */
  execute(vo: { IconCode: any; IconCodeBranch: any; UpdateDate: any; }, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deleteCwsIconFileData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteMarkService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
